import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../services/Acc_Utility.service';
import { Global } from '../global';
import { Observable } from 'rxjs';
import { AccountMappingService } from '../../services/AccountMappingService';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { InvoiceService } from '../../services/Acc_InvoiceService';
import { MatDatepickerInputEvent, MatSnackBar, SELECT_PANEL_INDENT_PADDING_X } from '@angular/material';
import * as moment from 'jalali-moment';
import { MatDialog } from '@angular/material';
import * as $ from 'jquery';
import { UserDetails } from '../../models/userDetails.interface';
import { GL_MasterService } from '../../services/Acc_GL_Master.service';
import { DariCalendarService } from '../../services/DariCalendar';
import { ExcelService } from '../../services/ExcelService';
import { DashboardService } from '../../services/dashboard.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};
  StudentAccounts: any;
  selectedAccountNumber: string = 'all';
  selectedAccountName: string;
  clear_status: string = 'A';
  expiry_status: string = 'A';
  semester: number = 0;
  fromDate: string;
  toDate: string;
  isPrintable: boolean;
  isFeeSemester: boolean = false;
  ArrAccountMaps: any;
  studentMasterAccount: string;
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  userList: any = {};
  departmentList: any;
  st_department: string = 'all';
  type_card: number = 0;
  printVariables: any = {};
  recordCount: number;
  amount_sum: number = 0;
  userDetails: UserDetails;
  branch: string;
  DateCheck = true;
  constructor(
    public dialog: MatDialog,
    private UtilityService: UtilityService,
    private UserService: UserService,
    private DariCalendar: DariCalendarService,
    private snackBar: MatSnackBar,
    private excelService: ExcelService,
    private userDetailService: DashboardService
  ) {
    //this.getInvoices();
    this.userDetailService.getUserDetails()
      .subscribe((userDetails: UserDetails) => {
        this.userDetails = userDetails;
        console.log(`user details ` + this.userDetails["email"]);
      }, error => {
        console.log(error);
      });
  }

  ngOnInit() {
    this.getBranchId();
    this.getUsers();
    //this.getDepartments();
  }

  is_allow_save: boolean = true;
  isBranchId: number = -1;
  userId: string = "0";
  getBranchId() {
    console.log("getBranchId:start")
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId;
    }
    console.log(`getBranchId:${this.isBranchId}`);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.StudentAccounts.filter(option => option.gL_ChildCode.toLowerCase().includes(filterValue));
  }

  getDepartments() {
    this.departmentList = this.UtilityService.getDepartments().subscribe(response => {
      console.log(response);
      this.departmentList = response;
    }
    )
  }

  AccountChanged(event, gL_ChildDesc, gL_ChildCode) {
    console.log(event.isUserInput);
    if (event.isUserInput === true) {
      console.log(gL_ChildDesc);
      this.selectedAccountName = gL_ChildDesc;
    }
  }

  FromDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.fromDate = _date;
    //this.fromDate_DariDate = _pdate;
  }

  ToDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.toDate = _date;
  }

  getUsers() {
     
    this.UserService.getUsers().subscribe(response => {
       
      this.userList = response.json();
      this.recordCount = this.userList.length;
      });
  }

  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user/user-list.component.ts